import { ChangeEvent, FC } from "react";
import InputText from "../InputText/InputText";
import AutocompleteInput from "../Autocomplete/AutocompleteInput";
import InputSelect from "../InputSelect/InputSelect";
import VehiclePelak from "../VehiclePelak/VehiclePelak";
import DatePickers from "../DatePicker/DatePicker";
import SimpleButton from "../SimpleButton/SimpleButton";
import TimeInput from "../TimePicker/TimeInput";
import PercentInput from "../PercentInput/PercentInput";
import Checkbox from "../../components/checkbox/Checkbox";
import MultiLineText from "../MultiLineText/MultiLineText";
import MultiSelect from "../multiselect/MultiSelect";
import TimeCalender from "../../components/TimeCalender";
import VehiclePelakSuggest from "../VehiclePelak/VehiclePelakSuggest";
import InputNumber from "global/InputNumber/InputNumber";
import MultiDatePicker from "global/DatePicker/multi-date-picker";
import { HiOutlineArrowLeft } from "react-icons/hi";

interface CustomPersonalizeFormProps {
  element: any;
  formik: any;
  selectOptions?: any;
  onChangeValue?: (e: ChangeEvent<HTMLInputElement>) => void;
  fetchInputOnchange?: (
    valueName: string,
    value: string,
    optionName: string
  ) => void;
  customClass?: string;
  setselectHub?: any;
}
const CustomPersonalizeForm: FC<CustomPersonalizeFormProps> = ({
  element,
  formik,
  selectOptions,
  fetchInputOnchange,
  customClass,
  setselectHub,
}) => {
  const { values, setFieldValue, handleChange, touched, errors } = formik;
  switch (element.type) {
    case "InputText":
      return (
        <InputText
          wrapperClassName={element.WrapperClassName || customClass}
          important={element.important}
          readOnly={element.readOnly}
          name={element.valueName}
          values={values[element.valueName]}
          label={element.label}
          handleChange={setFieldValue}
          error={touched[element.valueName] && errors[element.valueName]}
        />
      );
    case "inputText2":
      return (
        <InputText
          wrapperClassName={element.WrapperClassName || customClass}
          important={element.important}
          readOnly={element.readOnly}
          name={element.valueName}
          values={values[element.valueName]}
          label={element.label}
          handleChange={handleChange}
          error={touched[element.valueName] && errors[element.valueName]}
        />
      );
    case "text":
      return (
        <AutocompleteInput
          items={selectOptions ? selectOptions[element.options] : []}
          wrapperClassName={element.WrapperClassName || customClass}
          important={element.important}
          value={values[element.valueName]}
          label={element.label}
          onSelect={(val: any) => setFieldValue(element.valueName, val)}
          onChange={(e) => {
            fetchInputOnchange
              ? fetchInputOnchange(
                  element.valueName,
                  e.target.value,
                  element.options ? element.options : ""
                )
              : setFieldValue(element.valueName, e.target.value);
          }}
        />
      );
    case "inputSelect":
      return (
        <InputSelect
          wrapperClassName={element.WrapperClassName || customClass}
          important={element.important}
          isDisabled={element.readOnly}
          label={element.label}
          handleChange={setFieldValue}
          name={element.valueName}
          values={values[element.valueName]}
          options={selectOptions[element.options]}
          error={touched[element.valueName] && errors[element.valueName]}
          positionFixed
        />
      );
    case "inputSelect2":
      return (
        <InputSelect
          wrapperClassName={element.WrapperClassName || customClass}
          important={element.important}
          isDisabled={element.readOnly}
          label={element.label}
          handleChange={(name: string, value: any) => {
            setselectHub({ id: value.id, text: value.text });
            setFieldValue("selectHub", { id: value.id, text: value.text });
          }}
          name={element.valueName}
          values={values[element.valueName]}
          options={selectOptions[element.options]}
          error={touched[element.valueName] && errors[element.valueName]}
          positionFixed
        />
      );
    case "multiSelect":
      return (
        <MultiSelect
          wrapperClassName={element.WrapperClassName || customClass}
          label={element.label}
          name={element.valueName}
          handleChange={setFieldValue}
          values={values[element.valueName]}
          options={
            selectOptions[element.options] ? selectOptions[element.options] : []
          }
          error={touched[element.valueName] && errors[element.valueName]}
        />
      );
    case "pelak":
      return (
        <VehiclePelak
          important={element.important}
          formik={formik}
          ReadOnly={element.readOnly}
          label={element.label}
        />
      );

    case "pelakSuggestion":
      return (
        <VehiclePelakSuggest
          Search
          isSuggest
          formik={formik}
          label={element.label}
          WrapperClassName={element.WrapperClassName || customClass}
        />
      );
    case "date":
      return (
        <DatePickers
          WrapperClassName={customClass}
          important={element.important}
          Now={element.now}
          readOnly={element.readOnly}
          title={element.label}
          name={element.name}
          values={values[element.name]}
          handleChange={setFieldValue}
          error={touched[element.name] && errors[element.name]}
        />
      );
    case "date2":
      return (
        <DatePickers
          WrapperClassName={customClass}
          important={element.important}
          Now={element.now}
          readOnly={element.readOnly}
          title={element.label}
          name={element.valueName}
          values={values[element.valueName]}
          handleChange={setFieldValue}
          error={touched[element.valueName] && errors[element.valueName]}
        />
      );
    case "button":
      return (
        <SimpleButton
          type={element.btnType}
          className="full-tomato-btn"
          text={element.label}
          handelClick={selectOptions[element.name]}
        />
      );
    case "time":
      return (
        <TimeInput
          important={element.important}
          label={element.label}
          name={element.name}
          value={values[element.name]}
          onValueChange={({ formattedValue }: any) => {
            setFieldValue(element.name, formattedValue);
          }}
          error={touched[element.name] && errors[element.name]}
        />
      );
    case "TimeCalender":
      return (
        <div className="col-span-1 ">
          <TimeCalender
            WrapperClassName={"w-[240px]" || customClass}
            StartDateName={element.startValueName}
            StartDateValues={values[element.startValueName]}
            EndDateValues={values[element.endValueName]}
            EndDateName={element.endValueName}
            handleChange={setFieldValue}
            title={element.label}
          />
        </div>
      );
    case "percent":
      return (
        <PercentInput
          important={element.important}
          label={element.label}
          name={element.name}
          handleChange={handleChange}
          values={values[element.name]}
          error={touched[element.name] && errors[element.name]}
          wrapperClassName={customClass}
        />
      );
    case "checkbox":
      return (
        <Checkbox
          title={element.label}
          handleChange={handleChange}
          name={element.name}
          values={values[element.name]}
        />
      );
    case "multiLine":
      return (
        <MultiLineText
          label={element.label}
          name={element.name}
          values={values[element.name]}
          handleChange={handleChange}
          error={touched[element.name] && errors[element.name]}
          wrapperClassName={customClass}
        />
      );

    case "inputNumber":
      return (
        <InputNumber
          handleChange={setFieldValue}
          prefix={element.perfix}
          placeholder={element.plcaholder}
          wrapperClassName={element.WrapperClassName || customClass}
          important={element.important}
          readOnly={element.readOnly}
          name={element.valueName}
          values={values[element.valueName]}
          label={element.label}
          error={touched[element.valueName] && errors[element.valueName]}
          notSeparator
        />
      );
    case "multiDatePicker":
      return (
        <div className="flex float-left  gap-2 w-[20rem]  items-center autocompleteWrapper focus:shadow-none">
        <MultiDatePicker
          WrapperClassName={customClass}
          important={element.important}
          Now={element.now}
          readOnly={element.readOnly}
          title={element.label}
          name={element.valueName}
          values={values[element.valueName]}
          handleChange={setFieldValue}
          onlyMonthPicker={element.onlyMonthPicker}
        
        />
        <div className=" w-12">
          <HiOutlineArrowLeft />
        </div>
        <MultiDatePicker
          WrapperClassName={customClass}
          important={element.important}
          Now={element.now}
          readOnly={element.readOnly}
          title={ element.label2 || element.label}
          name={element.valueName2}
          values={values[element.valueName2]}
          handleChange={setFieldValue}
          onlyMonthPicker={element.onlyMonthPicker}
        />
      </div>
      );
    case "grid":
      return <div></div>;
    default:
      return <></>;
  }
};

export default CustomPersonalizeForm;
